module.exports = __webpack_public_path__ + "static/media/red-tulip.e85c0bbc.jpg";